import { Flex, Grid, Spacer } from '@chakra-ui/react'
import { Button, Panel, PlusIcon, SparklesIcon, Text } from 'components'
import { useCurrentUser, useWorkspace } from 'components/providers'
import { createTimestamp, useBreakpoint } from 'utils'
import noSmartColumns from '../../assets/emptyStates/no_smart_columns.svg'
import { createNewSmartColumn } from '../../utils'
import CreateNewButton from '../CreateNewButton'
import EmptyState from '../EmptyState'
import SmartColumnConfigurer from './SmartColumnConfigurer'

export default function SmartColumnPanel() {
  const { updateWorkspace, workspace } = useWorkspace()
  const user = useCurrentUser()
  const { smartColumnsConfig } = workspace || {}
  const { lookUpIds } = smartColumnsConfig || {}
  const breakpoint = useBreakpoint()

  if (!user || !workspace) return null
  async function handleNew() {
    if (!user || !workspace) return

    const res = await createNewSmartColumn(user.id, workspace)
    await updateWorkspace({
      smartColumnsConfig: {
        ...smartColumnsConfig,
        updated: createTimestamp(),
        lookUpIds: [...(lookUpIds || []), res.id],
      },
    })
  }
  return (
    <Panel p={5} pt={8} gap={4} w="100%">
      <Flex gap={3} align="center">
        <SparklesIcon color="primary.500" />
        <Text textStyle="h6">Smart Columns</Text>
        <Spacer />
        {breakpoint > 3 && (
          <Button leftIcon={<PlusIcon fontSize="sm" />} onClick={handleNew}>
            New Smart Column
          </Button>
        )}
      </Flex>
      {!!lookUpIds?.length ? (
        <Flex direction="column" gap={2} overflow="auto" pb={3}>
          {breakpoint > 3 ? (
            <Grid templateColumns="15px 280px 225px 200px 100px" gap={3}>
              <Spacer />
              <Text {...headingTextProps}>Title</Text>
              <Text {...headingTextProps}>Created By</Text>
              <Text {...headingTextProps}>Last Updated</Text>
              <Text {...headingTextProps}>Values</Text>
            </Grid>
          ) : (
            <Text textStyle="bodySmall" opacity={0.6}>
              Please access this page on a larger screen to add or edit smart columns
            </Text>
          )}
          {lookUpIds.map(id => {
            return <SmartColumnConfigurer key={id} lookUpId={id} />
          })}
        </Flex>
      ) : (
        <EmptyState
          title="No Smart Columns"
          description="No smart columns have been configured yet."
          iconSrc={noSmartColumns}
          iconProps={{ height: '176px' }}
          button={<CreateNewButton />}
        />
      )}
    </Panel>
  )
}

const headingTextProps = {
  textStyle: 'bodySmall',
}
